const window = require('window');
const Backbone = require('backbone');
const QuickAddProductCard = require('app/views/store/common/_quick_add_product_card');
const LocationModel = require('app/models/store/client/common/location');
const jsCookie = require('js-cookie');
const { ZipChangerView } = require('app/views/store/common/zip_changer');
const dustjs = require('dustjs');
const RestrictionsTemplate = require('app/templates/store/global/pages/products/_restrictions.dust');
const pluralize = require('pluralize');
const policyMap = require('./_restrictions_policy_map');
const { cookies } = require('lib/enums');

require('app/templates/store/global/common/_quick_add_product_card.dust');
require('app/templates/store/global/components/select_box/_select_box.dust');
require('app/templates/store/global/pages/products/_restriction_icon.dust');

const RestrictonsView = Backbone.View.extend({
	el: '#product-restrictions',
	events: {
		'click .js-change-zip': 'showChangeZipForm'
	},
	initialize: function(options = {}) {
		this.collection = options.collection || [];
		this.$container = options.containerEl ? $(options.containerEl).first() : $('.js-product-restrictions-container').first();
		this.zipcodeInfo = window.dataLayer.zipcodeInfo;
		this.finishes = options.finishes;
		this.productCompositeId = options.productCompositeId;
		this.restrictedUniqueId = 0;
		this.selectedFinish = options.selectedFinish;
		this.alternativeProductUniqueId = 0;
		this.restrictionVisible = false;
		this.enableSalesRestrictionCTA = window.dataLayer.enableSalesRestrictionCTA;
		this.$finishIndicator = $('.js-finish-restriction');
		const zipCode = this.zipcodeInfo ? this.zipcodeInfo.zipCode : jsCookie.get(cookies.POSTAL_CODE);
		if (zipCode) {
			this.zipChanged(zipCode, true);
		}
		this.listenTo(Backbone, 'zipCode:changed', this.zipChanged);
		this.listenTo(Backbone, 'restriction:remove', this.removeRestriction, this);
		this.listenTo(Backbone, 'restriction:add', this.addRestriction, this);
		this.listenTo(Backbone, 'finish:clicked', this.updatedFinish, this);
	},
	updatedFinish(finish) {
		this.selectedFinish = finish;
		// Use finish specific restrictions
		if (finish.restrictions && finish.restrictions.length && this.zipcodeInfo) {
			this.collection = finish.restrictions;
			const restrictionsApplied = this.applicableRestrictions(this.zipcodeInfo.stateAbbr || this.zipcodeInfo.state);
			this.storeUniqueIds(this.collection);
			this.toggleRestriction(restrictionsApplied);
			return;
		}
		// Use product restriction
		if (this.restrictedUniqueId && finish && this.restrictedUniqueId !== finish.uniqueId) {
			this.toggleRestriction(false);
		} else if (!this.restrictionVisible && this.zipcodeInfo) {
			const restrictionsApplied = this.applicableRestrictions(this.zipcodeInfo.stateAbbr || this.zipcodeInfo.state);
			this.storeUniqueIds(this.collection);
			this.toggleRestriction(restrictionsApplied);
		}
	},
	storeUniqueIds(restrictions) {
		restrictions.forEach((restriction) => {
			if (restriction.uniqueId) {
				this.restrictedUniqueId = restriction.uniqueId;
			}
			if (restriction.alternativeProductUniqueId) {
				this.alternativeProductUniqueId = restriction.alternativeProductUniqueId;
			}
		});
	},
	applicableRestrictions(stateCode) {
		return window.BCOM.util.getApplicableRestrictions(this.collection, stateCode);
	},

	zipChanged(zipCode, isInitialZip) {
		const locationModel = new LocationModel({
			zipCode: zipCode
		});
		$('.js-zip').val(zipCode);
		this.isInitialZip = isInitialZip;
		locationModel.fetch({
			success: this._successLocation.bind(this)
		});
	},
	_successLocation(data) {
		if (!data) {
			return;
		}
		data = data.toJSON();
		if (!data.state) {
			return;
		}
		this.zipcodeInfo = data;
		$('.js-zip').val(this.zipcodeInfo.zipCode);
		Backbone.trigger('zipCode:forceupdate', this.zipcodeInfo.zipCode);
		const restrictionsApplied = this.applicableRestrictions(data.state);
		this.storeUniqueIds(this.collection);
		if (!this.isInitialZip) {
			window.dataLayer.zipCodeChangeEvent = true;
			window.dataLayer.restrictions = restrictionsApplied;
			window.dataLayer.isRestrictionsUpdateComplete = true;
			if (window.dataLayer.isEstimatedDeliveryUpdateComplete) {
				Backbone.trigger('zipCode:successLocation');
			}
		}
		this.toggleRestriction(restrictionsApplied);
	},
	toggleRestriction(restrictionsApplied) {
		if (restrictionsApplied && restrictionsApplied.length) {
			Backbone.trigger('restriction:add');
			this.renderRestriction(restrictionsApplied);
			this.restrictionVisible = true;
		} else {
			Backbone.trigger('restriction:remove');
			this.restrictionVisible = false;
			const estimatedText = $('.js-zip-change-button').text();
			if (estimatedText.toLowerCase() === 'cancel') {
				$('.js-zip-change-button').trigger('click');
			}
			if (this.sameRecommendedProduct) {
				this.renderFinishRestrictionIndicator();
			}
		}
	},
	showChangeZipForm() {
		this.$el.find('.js-change-zip-form').toggleClass('dn');
	},
	removeRestriction() {
		this.$el.addClass('hide');
		if (this.sameRecommendedProduct) {
			this.$finishIndicator.addClass('hide');
		}
		if (window.dataLayer.isLocalUser) {
			return;
		}
		this.handleNoRestrictions();
	},
	addRestriction() {
		this.$el.removeClass('hide');
		if (this.sameRecommendedProduct) {
			this.$finishIndicator.removeClass('hide');
		}
		if (window.dataLayer.isLocalUser) {
			return;
		}
		this.handleRestrictions();
	},
	handleRestrictions() {
		// For PDP
		$('.js-purchase-box-container').addClass('hide');
		$('.js-restricted-container').addClass('hide');
		// For PLA
		$('.js-purchase-box-quantity').addClass('hide');
		$('.js-purchase-box-add-to-cart').addClass('hide');
	},
	handleNoRestrictions() {
		// For PDP
		$('.js-purchase-box-container').removeClass('hide');
		$('.js-restricted-container').removeClass('hide');
		// For PLA
		$('.js-purchase-box-quantity').removeClass('hide');
		$('.js-purchase-box-add-to-cart').removeClass('hide');
	},
	hasSameRecommendedProduct(alternateProducts) {
		if (!alternateProducts || !alternateProducts.length) {
			return false;
		}
		let isSame = false;
		alternateProducts.forEach((alternateProduct) => {
			if (alternateProduct.productCompositeId === this.productCompositeId) {
				isSame = true;
			}
		});
		return isSame;
	},
	renderRestriction(applicableRestrictions) {
		const alternativeProductUniqueId = this.alternativeProductUniqueId;
		const alternateProducts = this.getAlternateProducts(applicableRestrictions);
		const sameRecommendedProduct = this.hasSameRecommendedProduct(alternateProducts);
		const alternateCta = this.getAlternateCta(applicableRestrictions);
		const selectedMainFinish = this.selectedFinish;
		this.sameRecommendedProduct = sameRecommendedProduct;
		if (applicableRestrictions) {
			dustjs.render(
				RestrictionsTemplate,
				{
					show: true,
					sameRecommendedProduct,
					restrictions: applicableRestrictions,
					zipcodeInfo: this.zipcodeInfo,
					isClient: true,
					alternateCta,
					baseCategory: this.getBaseCategoryName()
				},
				function(err, out) {
					if (out) {
						if (sameRecommendedProduct) {
							$('.js-finish-restriction').html(out);
							this.renderFinishRestrictionIndicator();
							return;
						} else {
							this.$container.html(out);
						}
						// rebind events
						this.delegateEvents();
						if (!window.dataLayer.isLocalUser) {
							this.handleRestrictions();
						}
						if (alternateProducts && alternateProducts.length) {
							let selectedFinish;
							const alternateProduct = alternateProducts[0];
							if (alternativeProductUniqueId) {
								selectedFinish = alternateProduct.finishes.find((finish) => finish.uniqueId === alternativeProductUniqueId);
							} else if (selectedMainFinish) {
								selectedFinish = alternateProduct.finishes.find(
									(finish) => finish.finish.toLowerCase() === selectedMainFinish.finish.toLowerCase()
								);
							}
							this.quickAddProductCardView = new QuickAddProductCard({
								model: alternateProduct,
								selectedFinish,
								hideAddToCart: true,
								urlTrackingKey: 'product-restrictions'
							});
						}
					} else {
						window.clientErrorHandler(err);
					}
				}.bind(this)
			);
			this.zipChangerView = new ZipChangerView({
				el: '.js-restriction-zip-code-form'
			});
		}
	},
	/**
	 * Retrives alternativeProduct recommendations from the restrictions.
	 *
	 * @param {*} restrictions
	 * @returns
	 */
	getAlternateProducts(restrictions) {
		const alternateProducts = [];
		restrictions.forEach((restriction) => {
			if (restriction.alternativeProductDrop) {
				alternateProducts.push(restriction.alternativeProductDrop);
			}
		});
		return alternateProducts;
	},
	/**
	 * Displays a retriction icon on the finishes
	 *
	 * @returns {void}
	 */
	renderFinishRestrictionIndicator() {
		if (!this.finishes) {
			return;
		}
		this.finishes.forEach((finish) => {
			const applicableRestrictions = this.getApplicableRestrictions(finish.restrictions, this.zipcodeInfo.state);
			const $indicator = $(`.js-finish-${finish.uniqueId}`).find('.js-restriction-indicator');
			if (applicableRestrictions && applicableRestrictions.length) {
				$indicator.removeClass('dn').addClass('inline-flex');
			} else {
				$indicator.removeClass('inline-flex').addClass('dn');
			}
		});
	},
	getAlternateCta(applicableRestrictions) {
		let alternateCta = {};
		if (!Array.isArray(applicableRestrictions) || !this.enableSalesRestrictionCTA) {
			return alternateCta.alternateCta;
		}
		const siteId = window.dataLayer.siteId;
		const alternates = policyMap[applicableRestrictions[0].policyDescription];
		if (alternates) {
			alternateCta = alternates.find((a) => {
				return a.siteId === siteId;
			});
		}
		return alternateCta ? alternateCta.alternateCta : undefined;
	},
	getBaseCategoryName() {
		if (window.dataLayer.product && window.dataLayer.product.application) {
			return pluralize(window.dataLayer.product.application);
		}
		return pluralize(window.dataLayer.baseCategory || 'Products');
	}
});

module.exports = RestrictonsView;
